// 頁頂接手條（SPEC #kinio-kms-handover「接手頁」：組織還有 built_by_partner 時，客戶在 VMS 每頁頂端看到「〈安裝商〉替你建立了這個組織，
// 還差 N 步完成接手〔繼續〕」；代建者看到自己那邊的版本）。只對目前範圍的組織、只有代建者與接手客戶看得到；kmgr 讀不到時不寫步數。
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { useApp } from '../../../lib/AppContext';
import { useScope } from '../../../lib/scope';
import { useKmgrEnv } from '../hooks';
import { NS } from '../parts';
import { handoverApi } from './api';
import { showBanner } from './model';

export function HandoverBanner() {
  const { t } = useTranslation(NS);
  useKmgrEnv();
  const { session } = useApp();
  const { org } = useScope();
  const me = session?.user?.user_id ?? '';
  const on = showBanner(org, me);
  const q = useQuery({ queryKey: ['kmgr', 'handover', org?.org_id], queryFn: () => handoverApi.get(org!.api, org!.org_id), enabled: on, retry: 0, staleTime: 30_000 });
  if (!on || !org) return null;
  const builder = org.built_by_user_id === me;
  const partner = q.data?.built_by_partner.name || t('handover.partner_fallback');
  const n = q.data?.remaining;
  const text = builder ? t('handover.banner_builder', { org: org.display_name }) : t('handover.banner_customer', { partner });
  return (
    <p className="km-bar warn" role="status" data-testid="km-ho-banner" style={{ margin: '0 0 var(--space-3)' }}>
      <span className="ic" aria-hidden>
        ⓘ
      </span>
      <span className="txt">
        {text}
        {n !== undefined ? t('handover.banner_steps', { n }) : ''}
      </span>
      <Link className="btn btn-sm" to={'/org/kmgr/handover?org=' + encodeURIComponent(org.org_id)}>
        {t('handover.banner_continue')}
      </Link>
    </p>
  );
}
